import TableCell from '@material-ui/core/TableCell/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import BaseTable from 'packages/tables/BaseTable';
import useTablePagination from 'packages/hooks/use-table-pagination';
import {NATIONAL_RANKING_HEADERS} from 'packages/constants/table-constants';
import TableRow from '@material-ui/core/TableRow/TableRow';
import {Button, makeStyles} from '@material-ui/core';
import {useQuery} from '@apollo/client';
import {GET_NATIONALSTANDING, GET_USERS} from 'packages/graphql/v2/queries';
import {User} from 'packages/common-types/schema-types';
import {useEffect, useState} from 'react';
import NationalStandingByUser from 'packages/dialogs/NationalStandingByUser';
import {useModal} from 'packages/hooks/use-modal';

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
    padding: '35px',
    display: 'flex',
    flexDirection: 'column',
  },
});

type GetRankingData = {
  getRankings: {
    uid: string;
    ranking: number;
    supports: {
      tournamentData: {
        name: string;
        startDate: string;
        finishDate: string;
        address: {
          country: string;
          state: string;
          city: string;
        };
        conditions: {
          gender: string;
          numberOfRounds: number;
          tournamentType: string;
          modalityGame: string;
          pointLimit: number;
          tournamentCategory: string;
        };
      };
      stats: {
        place: number;
        matchesWon: number;
        matchesLose: number;
        matchDifference: number;
        pointsAgainst: number;
        pointsInFavor: number;
        pointDifference: number;
      };
      rankingObtained: number;
    }[];
  }[];
};

type GetUsersData = {
  getUsers: User[];
};

const NationalRanking = () => {
  const {data} = useQuery<GetRankingData>(GET_NATIONALSTANDING);
  const {data: dataUser} = useQuery<GetUsersData>(GET_USERS);
  const styles = useStyles();
  const {onChangePage, onChangeRowsPerPage, page, rowsPerPage} =
    useTablePagination();
  const [nationalRankings, setNationalRankings] = useState([]);
  const {toggle, modalOpen} = useModal();
  const [support, setSupport] = useState([]);

  useEffect(() => {
    if (data?.getRankings && dataUser?.getUsers) {
      const rankings = data?.getRankings
        .map(({uid, ranking, supports}) => {
          const {fullName} = dataUser?.getUsers.find(
            ({uid: uidUser}) => uid === uidUser
          );
          return {
            fullName,
            ranking,
            supports,
          };
        })
        .sort(({ranking: a}, {ranking: b}) => b - a);
      setNationalRankings(
        [...rankings]
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(({supports, fullName, ranking}, index) => {
            const names = supports.map(({tournamentData}) => {
              return tournamentData.name;
            });
            return (
              // eslint-disable-next-line react/no-array-index-key
              <TableRow key={index}>
                <TableCell align="left">{index + 1}</TableCell>
                <TableCell align="left">{fullName}</TableCell>
                <TableCell align="left">
                  {names.length > 0 ? names[0] : '--'}
                </TableCell>
                <TableCell align="left">
                  {names.length > 1 ? names[1] : '--'}
                </TableCell>
                <TableCell align="left">
                  {names.length > 2 ? names[2] : '--'}
                </TableCell>
                <TableCell align="left">
                  {names.length > 3 ? names[3] : '--'}
                </TableCell>
                <TableCell align="left">
                  {names.length > 4 ? names[4] : '--'}
                </TableCell>
                <TableCell align="left">
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setSupport(supports);
                      toggle();
                    }}
                  >
                    Ver mas
                  </Button>
                </TableCell>
                <TableCell align="left">{ranking}</TableCell>
              </TableRow>
            );
          })
      );
    }
  }, [data, dataUser, page, rowsPerPage, toggle]);

  return (
    <>
      <NationalStandingByUser
        modalOpen={modalOpen}
        toggle={toggle}
        supports={support}
      />
      <div className={styles.root}>
        <h1>Ranking nacional</h1>
        <BaseTable variant="leaderboard" headers={NATIONAL_RANKING_HEADERS}>
          {nationalRankings}
        </BaseTable>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={[].length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
        />
      </div>
    </>
  );
};

export default NationalRanking;
